import { render, staticRenderFns } from "./CustomTemplates.vue?vue&type=template&id=8f00b00e&"
import script from "./CustomTemplates.vue?vue&type=script&lang=ts&"
export * from "./CustomTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports